
const Threedots = ( ) => {

  
    return (
        <div id="threedots">
          <h1>This is the section for the threedots</h1>
           
    </div>
  );
};
 
export default Threedots;